import ProjectsReportModal from "./ProjectsReportModal"

export default ProjectsReportModal
